export default __webpack_public_path__ + "static/media/PMT_M121_05.1cc41332.svg";